// list of the main Routes
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home  from './Components/Home';
import About from './Components/About';
import Login from './Components/Login';
import Logout from './Components/Logout';
import UserCompanyList from './Components/ChangeCompany';
import EsaedroObjectEdit from './Components/EsaedroObjectEdit';
import EsaedroObjectsList from './Components/EsaedroObjectsList';
import EsaedroObjectDelete from './Components/EsaedroObjectDelete';
import EsaedroContentPage from './Components/EsaedroContentPage';
import UserProductList from './Components/ChangeProduct';
import ChangePassword from './Components/ChangePassword';

const reload = () => window.location.reload();

export const AppRoutes = 
    <React.Fragment>
        <Switch>
            <Route exact path='/' component={ Home } />
            <Route path='/about' component={ About } />
            <Route path="/login" component={Login}></Route>
            <Route path="/changePassword" component={ChangePassword}></Route>
            <Route path="/objectslist/:myObjType/:myObjUrl?" component={EsaedroObjectsList}  />
            <Route path="/objectedit/:myObjType/:myObjUrl/:isNew?" component={EsaedroObjectEdit} />
            <Route path="/objectdelete/:myObjType/:myObjUrl?" component={EsaedroObjectDelete} />
            <Route path="/logout" component={Logout}></Route>
            <Route path="/changecompany" component={UserCompanyList}></Route>
            <Route path="/changeproduct" component={UserProductList}></Route>
            <Route path="/content" component={EsaedroContentPage}></Route>
            <Route path="/home" component={EsaedroContentPage}></Route>
            <Route path="/app.config.json"  onEnter={reload} />
            <Route component={ Home } />
        </Switch>
    </React.Fragment>;
